
import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`;



export const fetchPublicationTableQuery = async (page: number, limit: number, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/publication/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

export const fetchPublicationQuery = async (lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/publication`, { headers: customHeaders });
  return response.data;
};

export const fetchPublicationByIdQuery = async (id: string, lan: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.get(`${API_URL}/${lan}/publication/${id}`, { headers: customHeaders });
  return response.data;
};

export const addPublicationQuery = async (newPublication: { name: string; description: string; photo: string }) => {
  const response = await axiosInstance.post(`${API_URL}/publication`, newPublication, {
    headers: {
      'Content-Type': 'multipart/form-data', // If photo is included as a file
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

export const updatePublicationQuery = async (id: string, updatedPublication: { name: string; description: string; photo?: string }, lan: string) => {
  const response = await axiosInstance.put(`${API_URL}/${lan}/publication/${id}`, updatedPublication, {
    headers: {
      'Content-Type': 'multipart/form-data', // If photo is included as a file
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });
  return response.data;
};

export const removePublicationQuery = async (id: string) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAuthToken()}`
  };
  const response = await axiosInstance.delete(`${API_URL}/publication/${id}`, { headers: customHeaders });
  return response.data;
};
